module.exports = __webpack_public_path__ + "img/cmg-logo.5b3fde7d.svg";